import React, { useEffect, useState, useRef } from "react";
import {
  Grid,
  Card,
  Icon,
  Popup,
  Modal,
  Header,
  Input,
} from "semantic-ui-react";
import CardPaginationTable from "../Pagination/CardPaginationTable";
import moment from "moment";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { getDatasetUsersRequestList } from "../../actions/dataConsoleAction";
import { set } from "react-hook-form";

const AllRequestData = ({ data, handleApprove, handleDeny }) => {
  const getTimeAgo = (createdUTC) => {
    const today = moment().startOf("day");
    const createdDate = moment.utc(createdUTC).local().startOf("day");

    const timeDifference = today.diff(createdDate, "days");

    if (timeDifference === 0) {
      return "Requested today";
    } else if (timeDifference === 1) {
      return "Requested yesterday";
    } else {
      return `Requested on ${timeDifference} days ago`;
    }
  };

  return (
    <Grid columns={3} stackable className="request-table">
      {data.length > 0
        ? data.map((row, index) => (
            <Grid.Column key={index}>
              <Card fluid className="qac-card">
                <Card.Content>
                  <Card.Header>
                    <div className="requestHeaderBox">
                      <div className="requestHeaderRow">
                        {row.datasetName.length < 22 ? (
                          row.datasetName
                        ) : (
                          <Popup
                            content={row.datasetName}
                            inverted
                            position="right center"
                            style={{ borderRadius: "15px" }}
                            trigger={
                              <span>{row.datasetName.slice(0, 22)}..</span>
                            }
                          />
                        )}
                      </div>
                      <div>
                        {row.role === "Admin" || row.role==="DatasetAdmin"? (
                          <>
                            <div className="user-admin-box">
                              <img
                                src="/images/user-admin-box.svg"
                                alt="pdf Icon"
                              />
                              <span className="usersRoleBox">Admin</span>
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="user-user-box">
                              <img
                                src="/images/user-user-box.svg"
                                alt="pdf Icon"
                              />
                              <span className="usersRoleBox">User</span>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </Card.Header>
                  <Card.Meta className="request-meta">
                    <div>
                      <span className="requestedCount">
                        <span className="request-count-box">
                          {row.files.length}
                        </span>
                        <span>Documents</span>
                      </span>
                    </div>
                  </Card.Meta>
                </Card.Content>
                <Card.Content extra className="qac-card-extra-content">
                  <div className="requestListFooter">
                    <div className="requestListFooterRow">
                      {getTimeAgo(row.createdUTC)}
                    </div>
                    <div className="user-card-icons grey-icons">
                      <div>
                        <img
                          className="tableButton"
                          src="/images/grey-decline.svg"
                          alt="deny"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDeny(row);
                          }}
                          style={{ cursor: "pointer" }}
                          data-cy="dataset-delete-link"
                        />
                      </div>
                      <div>
                        <img
                          className="tableButton"
                          src="/images/grey-tick.svg"
                          alt="Approve"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleApprove(row);
                          }}
                          style={{ cursor: "pointer" }}
                          data-cy="dataset-delete-link"
                        />
                      </div>
                    </div>
                    <div className="user-card-icons color-icons">
                      <div>
                        <img
                          className="tableButton"
                          src="/images/red-circle-delete.svg"
                          alt="deny"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDeny(row);
                          }}
                          style={{ cursor: "pointer" }}
                          data-cy="dataset-delete-link"
                        />
                      </div>
                      <div>
                        <img
                          className="tableButton"
                          src="/images/blue-tick.svg"
                          alt="Approve"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleApprove(row);
                          }}
                          style={{ cursor: "pointer" }}
                          data-cy="dataset-delete-link"
                        />
                      </div>
                    </div>
                  </div>
                </Card.Content>
              </Card>
            </Grid.Column>
          ))
        : ""}
    </Grid>
  );
};

const AdminUserDataset = ({
  handleApprove,
  handleDeny,
  singleRequestFlag,
  changeSingleRequestFlag,
  handleSendDatasetCount,
}) => {
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(9); // Default rows per page
  const isMounted = useRef(true);
  const dispatch = useDispatch();
  const { userIdParam, userNameParam } = useParams();
  const [DatasetUserRequestedData, setDatasetUserRequestedData] = useState([]);

  const { requestUserDatasetData, requestUserDatasetStatus } = useSelector(
    (state) => state.requestDatasetUserList || {}
  );

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const navigate = useNavigate();

  const getTimeAgo = (data) => {
    if (data.length === 0) {
      return "Requested today";
    }

    const createdUTC = data[0].createdUTC;
    const today = moment().startOf("day");
    const createdDate = moment.utc(createdUTC).local().startOf("day");

    const timeDifference = today.diff(createdDate, "days");

    if (timeDifference === 0) {
      return "Requested today";
    } else if (timeDifference === 1) {
      return "Requested yesterday";
    } else {
      return `Requested on ${timeDifference} days ago`;
    }
  };

  useEffect(() => {
    if (isMounted.current) {
      isMounted.current = false;
      getAllUserrequestedDtasets();
    }
  }, [isMounted, dispatch]);

  useEffect(() => {
    console.log("singleRequestFlag", singleRequestFlag);
    if (singleRequestFlag) {
      changeSingleRequestFlag();
      getAllUserrequestedDtasets();
    }
  }, [singleRequestFlag]);

  const getAllUserrequestedDtasets = () => {
    dispatch(getDatasetUsersRequestList(userIdParam));
  };

  useEffect(() => {
    if (requestUserDatasetStatus === 200) {
      if (requestUserDatasetData.length > 0) {
        const filteredData = requestUserDatasetData[0].datasets.filter(
          (item) => item.accessType === "RequestPending"
        );
        handleSendDatasetCount(filteredData.length);
        setDatasetUserRequestedData(filteredData);
        if (requestUserDatasetData[0].datasets.length > 0) {
          const filterIds = requestUserDatasetData[0].datasets.map(
            (dataset) => dataset.datasetId
          );
          sessionStorage.setItem(
            "requestusername",
            requestUserDatasetData[0].userName
          );
          sessionStorage.setItem("filterIds", JSON.stringify(filterIds));
        }
      } else {
        setDatasetUserRequestedData([]);
      }
    }
  }, [requestUserDatasetData, requestUserDatasetStatus]);

  return (
    <div>
      {DatasetUserRequestedData.length > 0 ? (
        <>
          <AllRequestData
            data={DatasetUserRequestedData.slice(
              currentPage * rowsPerPage,
              (currentPage + 1) * rowsPerPage
            )}
            handleApprove={handleApprove}
            handleDeny={handleDeny}
          />
          <CardPaginationTable
            totalItems={DatasetUserRequestedData.length}
            page={currentPage}
            rowsPerPage={rowsPerPage}
            handleChangePage={handleChangePage}
          />
        </>
      ) : (
        <>
          <div className="emptyContainer">
            <img src="/images/empty-state.svg" alt="Empty State" />
            <p className="emptyMessage">
              <span className="titleMessage">No data available </span>
            </p>
          </div>
        </>
      )}
    </div>
  );
};

export default AdminUserDataset;
